var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2H6.13239C5.42986 2 4.77885 2.3686 4.4174 2.97101L2.45001 6.25H11.25V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.25V2H17.8676C18.5701 2 19.2212 2.3686 19.5826 2.97101L21.55 6.25H12.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V7.75H2ZM8.46967 13.4697L11.4697 10.4697C11.7626 10.1768 12.2374 10.1768 12.5303 10.4697L15.5303 13.4697C15.8232 13.7626 15.8232 14.2374 15.5303 14.5303C15.2374 14.8232 14.7626 14.8232 14.4697 14.5303L12.75 12.8107V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V12.8107L9.53033 14.5303C9.23744 14.8232 8.76256 14.8232 8.46967 14.5303C8.17678 14.2374 8.17678 13.7626 8.46967 13.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox2);
export default __webpack_public_path__ + "static/media/box-2.1c14f16550292d0b194a30925ea58770.svg";
export { ForwardRef as ReactComponent };